const formatToThousandNumber = (value, precision) => {
  return (value / 1000).toFixed(precision) * 1 + 'K';
};

const formatToMillionNumber = (value, precision) => {
  return (value / 1000000).toFixed(precision) * 1 + 'M';
};

const formatToBillionNumber = (value, precision) => {
  return (value / 1000000000).toFixed(precision) * 1 + 'B';
};

export const formatLongNumber = (value = 0, precision = 2) => {
  if (value === 0) {
    return '0';
  } else {
    // hundreds
    if (value > 0 && value <= 999) {
      return value.toFixed(precision) * 1;
    }
    // thousands
    else if (value >= 1000 && value <= 999999) {
      return formatToThousandNumber(value, precision);
    }
    // millions
    else if (value >= 1000000 && value <= 999999999) {
      return formatToMillionNumber(value, precision);
    }
    // billions
    else if (value >= 1000000000 && value <= 999999999999) {
      return formatToBillionNumber(value, precision);
    }
    // formatting for numbers < 0
    else if (value < 0 && value * -1 >= 1000 && value * -1 <= 999999) {
      return formatToThousandNumber(value, precision);
    } else if (value < 0 && value * -1 >= 1000000 && value * -1 <= 999999999) {
      return formatToMillionNumber(value, precision);
    } else if (value < 0 && value * -1 >= 1000000000 && value * -1 <= 999999999999) {
      return formatToBillionNumber(value, precision);
    } else return value.toFixed(precision) * 1;
  }
};

export const formatInput = (input) => {
  if (input === undefined || input === null || input === 'NA' || input === 'N/A' || input === '') {
    return 'N/A';
  } else {
    const formattedValue = Number(input).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return formattedValue;
  }
};

export const formatNumberUsingUnit = (input, unit) => {
  const formatedInput = formatInput(input);
  if (formatedInput === 'N/A') {
    return 'N/A';
  }

  switch (unit) {
    case '$':
      return formatedInput.includes('-')
        ? '-' + unit + formatedInput.slice(1)
        : unit + formatedInput;
    case '%':
      return formatedInput + unit;
    case 'none':
      return formatedInput;
    default:
      return formatedInput;
  }
};

export const formatPercentValue = (val) =>
  typeof val === 'number' && !isNaN(val) ? val.toFixed(2) + '%' : 'N/A';
